import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxDeliveryComponent } from './nx-delivery.component';



@NgModule({
  declarations: [
    NxDeliveryComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NxDeliveryComponent
  ]
})
export class NxDeliveryModule { }
